<div #layoutContainer class="layout-container menu-layout-static menu-layout-horizontal">
  <aur-page [showSearch]="false"  [hasMaxWidth]="true" [constrain]="true">
    <div class="poe-header" [innerHTML]="poeHeader"></div>
    <aur-card>
      <div class="center">
        <div id="u1153" class="ax_default materialicons">
          <div id="u1153_text" class="text ">
            <p><span>error</span></p>
          </div>
        </div>
        <div id="u1151" class="ax_default heading_1">
          <div id="u1151_text" class="text ">
            <p><span>Email Link Expired</span></p>
          </div>
        </div>
        <div id="u1152" class="ax_default heading_3">
          <div id="u1152_text" class="text ">
            <p><span style="color:#1B222C;" class="spaceAlignment">We apologize for this inconvenience. </span></p>
            <!-- <p><span style="color:#1B222C;">If you need assistance, Please </span><span style="color:#169BD5;">Contact
                us.</span></p> -->
          </div>
        </div>
      </div>
      <br><br> <br><br>
    </aur-card>

  </aur-page>
</div>